const relatedProductsSlider = document.querySelectorAll('[data-slider="related-products__slider"]');

const relatedProductsSliderOptions = {
  slidesPerView: 1.2,
  spaceBetween: 20,
  speed: 800,
  watchOverflow: true,
  watchSlidesProgress: true,
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
    },
    1023: {
      slidesPerView: 3,
    },
  },
};

relatedProductsSlider.forEach((el) => {
  const parent = el.closest('.related-products');
  const scrollBarElement = parent.querySelector('.swiper-scrollbar');
  relatedProductsSliderOptions.scrollbar.el = scrollBarElement;

  new Swiper(el, relatedProductsSliderOptions);
});
